const validImageTypes = ["image/jpeg", "image/png"];
const validVideoTypes = ["video"];
const invalidProgramValues = ["Select Here", "Select Program"];
const invalidSocialValues = ['Select social media platform'];

export default function FormValidator(field: string, value: any) {
  const errors: any = {};
  switch (field) {
    case "fullName":
      if (!value[field] || !/^[a-zA-Z][a-zA-Z ]{1,49}$/.test(value[field])) {
        errors.fullName = "Please enter a valid full name";
      }
      break;
    case "phoneNumber":
      if (!value[field]) {
        errors[field] = "Please enter valid phone number";
      } else if (
        value.countryCode === "+91" &&
        !/^[1-9][0-9]{9}$/.test(value[field])
      ) {
        errors[field] = "Please enter valid phone number";
      } else if (!/^[1-9][0-9]{6,14}$/.test(value[field])) {
        errors[field] = "Please enter valid phone number";
      }
      break;
    case "email":
      if (
        !value[field] ||
        !/^[A-Z0-9._%+-]+@[A-Z0-9-]+\.[A-Z]{2,}$/i.test(value[field])
      ) {
        errors[field] = "Please enter a valid email address";
      }
      break;
    case "message":
      if (!value[field]) {
        errors.message = "Please enter some message";
      }
      break;
    case "country":
      if (!value[field]) {
        errors.message = "Please enter valid country name";
      }
      break;
    case "organization":
      if (!value[field] || !/^[a-zA-Z0-9. ]+$/.test(value[field])) {
        errors[field] = "Please enter valid organization name";
      }
      break;
    case "linkedIn":
      if (
        !value[field] ||
        !/^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/.test(
          value[field]
        )
      ) {
        errors[field] = "Please enter valid linked in url";
      }
      break;
    case "consent":
      if (!value[field]) {
        errors[field] = "Please accept terms & conditions";
      }
      break;

    case "program":
      if (!value[field] || invalidProgramValues.includes(value[field])) {
        errors[field] = "Please select a program";
      }
      break;
    case "Custom2" :
      if (!value[field]  || invalidSocialValues.includes(value[field])) {
        errors[field] = "Please select social media platform";
      }
      break;
      
    case "picture":
      if (!value[field] || !validImageTypes.includes(value[field]?.type)) {
        errors[field] = "Please upload valid picture";
      }else if(value[field]?.size > 10000000){
        errors[field] = "File size limit exceeded. Please upload a file smaller than 10MB";
      }
      break;

    case "video":
      if (!value[field] || !value[field]?.type.includes(validVideoTypes)) {
        if(!value[field]?.name.includes('.flv')){
          errors[field] = "Please upload valid video";
        }
      } else if (value[field]?.size > 100000000) {
        errors[field] = "File size limit exceeded. Please upload a file smaller than 100MB";
      }
      break;

    case "enrollmentId":
      if (!value[field] || !/^[a-zA-Z0-9]*$/.test(value[field])) {
        errors[field] = "Please enter valid enrollment id";
      }
      break;

    case "companyName":
      if (!value[field]) {
        errors[field] = "Please enter a valid company name";
      }
      break;

    case "resume":
      if (
        !value[field] ||
        !/application\/pdf/.test(value[field]?.type) ||
        value[field]?.size > 2097152
      ) {
        errors[field] = "Please upload a valid resume";
      }
      break;

    default:
      break;
  }
  return errors;
}
